import {UmpireUser} from '../umpire-user';

export interface UmpireComment {
  content: string;
  nick: string;
  id: string;
  type: 'comment';
  is_banned: boolean;
  user?: UmpireUser;
}
